import styled from 'styled-components';

export const Section = styled.section`
  width: 100%;
  padding: 140px 20px;
  background-color: #ff441f;
`;

export const Container = styled.div`
  margin: auto;
  max-width: 924px;
  border-radius: 12px;
  background-color: #d6391a;
  padding: ${({ screen }) => screen !== 'xs' ? '0 48px' : '0 24px'};
`;

export const Title = styled.h3`
  margin-bottom: 16px;
  margin-top: 40px;
  color: #fff;
`;

export const List = styled.ul`
  display: block;
  margin-bottom: 40px;
`;
